import { DataSpec } from './data-spec.js'
import { DataSpecQuery } from './data-spec-query.js'

export const entities = [DataSpec]
export const resolvers = [DataSpecQuery]
